module.exports = __webpack_public_path__ + "fonts/Myriad_Pro_Semibold.b9b1984c.ttf";